export default {
	"components.WeChat": "微信",
	"components.Alipay": "支付宝",
	"components.ScanCodeToPay": "后扫码支付",
	"components.SaveQRCode": "保存二维码",
	"components.detectedThatYouAreNotInstalled": "检测到您未安装",
	"components.PleaseInstall": "，请安装"
}